import "./style.css";
import { motion } from "framer-motion";
import { fadeInUp } from "../../../animations/fadeVariants";

const Qualification = () => {
  return (
    <section id="qualification" className="qualification">
      <motion.div {...fadeInUp}>
        <h1 className="title">Qualification</h1>
        <h1 className="qualification-description">
          We have registered for ISO 9001, 14001, 37001, 45001 certificate
        </h1>
        <div className="certificate-wrapper">
          <img src="images/dokumentasi/ISO9001.png" alt="ISO 9001 : 2015" />
          <img src="images/dokumentasi/ISO14001.png" alt="ISO 14001 : 2015" />
          <img src="images/dokumentasi/ISO37001.png" alt="ISO 37001 : 2016" />
          <img src="images/dokumentasi/ISO45001.png" alt="ISO 45001 : 2018" />
        </div>
      </motion.div>
    </section>
  );
};

export default Qualification;
